const colors = {
    blue: '#4557ff',
    darkSkyblue: '#C4F3FF',
    lightSkyblue: '#DFF9FF',
    white: '#FFFFFF',
    darkBlue: '#1F014B',
    darkGrey: '#6c757d',
    yellow: '#F7F0A1',
    red: '#DE296E',
    green: '#28a745',
    orange: '#E8BF40',
    lightBlue: '#2196f3',
    pink: '#FAD6F5',
    grey: '#C6CDD2',
    gold: '#C49B1D'
};

export default colors;  